const programing = [
  { id: 1, name: "C", image: "svg/c-logo.svg" },
  { id: 2, name: "Java", image: "svg/java-logo.svg" },
  { id: 3, name: "R", image: "svg/r-logo.svg" },
];

export default programing;
